module.exports = __webpack_public_path__ + "static/media/logo_org.3e5c067e.png";